import { render, staticRenderFns } from "./VehicleResultActions.vue?vue&type=template&id=45f0cb4a&"
import script from "./VehicleResultActions.vue?vue&type=script&lang=js&"
export * from "./VehicleResultActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports